import { FC, useMemo } from 'react';
import getVideoId from 'get-video-id';
import * as S from './styles';

type YoutubeIframeProps = {
  url: string;
};

const YoutubeIframe: FC<YoutubeIframeProps> = ({ url, ...rest }) => {
  const iframe = useMemo(() => {
    const { id } = getVideoId(url);
    const src = `https://www.youtube.com/embed/${id}`;
    return `<iframe class="youtube-section" src="${src}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  }, [url]);

  return <S.YoutubeIframe {...rest} dangerouslySetInnerHTML={{ __html: iframe }} />;
};

export default YoutubeIframe;
